import type { ReactNode } from 'react';
import { styled } from 'styled-components';

interface Props {
  children: ReactNode;
}

const Block = styled.main`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  background: #f0f2f5;
  padding: 24px;
  overflow-y: auto;
`;

export const ContentBlock = ({ children }: Props) => {
  return <Block>{children}</Block>;
};
